<ng-container *appI18nScopeReady>
  <h2 mat-dialog-title>{{ 'dialog_title' | i18n }}</h2>

  <mat-dialog-content class="section-manager-dialog">
    @if (loading()) {
      <div class="spinner-inline"><mat-spinner diameter="32" /></div>
    } @else {
      <div class="section-list" cdkDropList (cdkDropListDropped)="onDrop($event)">
        @for (item of sections(); track item.id) {
          <div class="section-row" cdkDrag>
            <mat-icon class="drag-handle" cdkDragHandle>drag_indicator</mat-icon>

            @if (!hideKeys) {
              <span class="key-chip" [matTooltip]="item.key">{{ item.key }}</span>
            }

            <mat-form-field class="label-field" appearance="outline" subscriptSizing="dynamic">
              <mat-label>{{ 'display_label' | i18n }}</mat-label>
              <input matInput [ngModel]="item.label" (ngModelChange)="onItemLabelChange(item.id, $event)" />
            </mat-form-field>

            @if (showGroupColumn) {
              <app-group-input
                class="group-field"
                [value]="item.group"
                (valueChange)="onItemGroupChange(item.id, $event)"
                [groups]="groupOptions"
                [label]="'group_label' | i18n"
              />
            }

            <mat-slide-toggle
              [ngModel]="item.visible"
              (ngModelChange)="onItemVisibleChange(item.id, $event)"
              [matTooltip]="item.visible ? ('visible' | i18n) : ('hidden' | i18n)"
            />

            @if (!hideDelete) {
              <button mat-icon-button [matTooltip]="'delete' | i18n" (click)="confirmDelete(item)">
                <mat-icon>delete</mat-icon>
              </button>
            }
          </div>
        }
      </div>

      @if (!hideAdd) {
        <div class="add-section">
          @if (!hideKeys) {
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <mat-label>{{ 'key_label' | i18n }}</mat-label>
              <input matInput [ngModel]="newKey()" (ngModelChange)="newKey.set($event)" />
            </mat-form-field>
          }
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ 'display_label' | i18n }}</mat-label>
            <input matInput [ngModel]="newLabel()" (ngModelChange)="newLabel.set($event)" />
          </mat-form-field>
          <button mat-flat-button [disabled]="(!hideKeys && !newKey()) || !newLabel() || isDuplicate() || saving()" (click)="addSection()">
            @if (saving()) {
              <mat-spinner diameter="18" />
            } @else {
              {{ 'add_btn' | i18n }}
            }
          </button>
        </div>
        @if (isDuplicate()) {
          <span class="duplicate-error-text">{{ 'duplicate_error' | i18n }}</span>
        }
      }
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="close()">{{ 'cancel' | i18n }}</button>
    <button mat-flat-button [disabled]="saving()" (click)="save()">
      @if (saving()) {
        <mat-spinner diameter="18" />
      } @else {
        {{ 'save' | i18n }}
      }
    </button>
  </mat-dialog-actions>
</ng-container>
